<footer class="govbook-footer">
	<div class="govbook-footer__pre-footer">
		<div class="govbook-container">
			<div class="row">
				<div class="col-sm-12 col-md-6">
					<ul class="menu menu--footer">
						<li class="menu-item">
							<a
								target="_blank"
								class="footer-links"
								href="https://www.barnsley.gov.uk/services/births-deaths-and-marriages/"
								>Births, deaths and marriages</a
							>
						</li>
						<li class="menu-item">
							<a
								target="_blank"
								class="footer-links"
								href="https://www.barnsley.gov.uk/services/births-deaths-and-marriages/marriages-and-civil-partnerships/"
								>Marriages and civil partnerships</a
							>
						</li>
						<li class="menu-item">
							<a
								target="_blank"
								class="footer-links"
								href="https://www.barnsley.gov.uk/services/births-deaths-and-marriages/registration-charges/"
								>Registration charges</a
							>
						</li>
						<li class="menu-item">
							<a
								target="_blank"
								class="footer-links"
								href="https://www.barnsley.gov.uk/services/births-deaths-and-marriages/order-copy-certificates/"
								>Order copy certificates</a
							>
						</li>
						<li class="menu-item">
							<a
								target="_blank"
								class="footer-links"
								href="https://www.barnsley.gov.uk/services/births-deaths-and-marriages/contact-registrars-and-where-to-find-us/"
								>Contact registrars and where to find us</a
							>
						</li>
						<li class="menu-item">
							<a
								target="_blank"
								class="footer-links"
								href="https://www.barnsley.gov.uk/services/contact-us/"
								>Contact Barnsley Council</a
							>
						</li>
					</ul>
				</div>

				<div class="col-sm-12 col-md-6">

                    <ul class="menu menu--footer">
            <li class="menu-item">
              <a target="_blank" class="footer-links"
                href="https://www.barnsley.gov.uk/website-information/website-disclaimer/">Disclaimer</a>
            </li>
            <li class="menu-item">
              <a target="_blank" class="footer-links"
                href="https://www.barnsley.gov.uk/services/information-and-privacy/your-privacy/">Privacy</a>
            </li>
            <li class="menu-item">
              <a target="_blank" class="footer-links"
                href="https://www.barnsley.gov.uk/website-information/how-we-use-cookies/">Cookies</a>
            </li>
            <li class="menu-item">
              <a target="_blank" aria-label="Accessibility statement (opens in new window)" rel="noopener noreferrer"
                class="footer-links" [routerLink]="['/accessibility-statement']">Accessibility statement</a>
            </li>
            <li class="menu-item">
              <a target="_blank" class="footer-links"
                href="https://www.barnsley.gov.uk/services/council-and-democracy/plans-strategies-and-performance/modern-slavery-statement/">Modern slavery</a>
            </li>
            <li class="menu-item">
              <a target="_blank" class="footer-links"
                href="https://www.barnsley.gov.uk/site-map">Site map</a>
            </li>
          </ul>
					<h4>Contact us</h4>
					<a
						target="_blank"
						class="footer-links"
						href="https://www.barnsley.gov.uk/services/births-deaths-and-marriages/contact-registrars-and-where-to-find-us/"
						>Contact registrars online</a
					>
					<span class="footer-links">&nbsp;or call 01226 773555</span>
					<nav
						aria-labelledby="block-ecc-theme-gov-socialmedia-menu"
						id="block-ecc-theme-gov-socialmedia"
						class="block block-menu navigation navigation--social-media"
					>
						<h2
							class="visually-hidden"
							id="block-ecc-theme-gov-socialmedia-menu"
						>
							Social Media
						</h2>

						<ul
							class="menu menu--social-media justify-content-end justify-content-md-start mt-3"
						>
							<li class="menu-item">
								<a
									target="_blank"
									aria-label="Facebook (opens in new window)"
									class="footer-links"
									href="https://www.facebook.com/BarnsleyCouncil"
									class="social-link facebook"
									>Facebook</a
								>
							</li>
							<li class="menu-item">
								<a
									target="_blank"
									aria-label="Youtube (opens in new window)"
									class="footer-links"
									href="https://www.youtube.com/user/barnsleymbc"
									class="social-link youtube"
									>YouTube</a
								>
							</li>
							<li class="menu-item">
								<a
									target="_blank"
									aria-label="Instagram (opens in new window)"
									class="footer-links"
									href="https://www.instagram.com/barnsleycouncilofficial"
									class="social-link instagram"
									>Instagram</a
								>
							</li>
						</ul>
					</nav>
				</div>
			</div>
		</div>
	</div>

	<div class="govbook-footer__footer">
		<div class="govbook-container">
			<div class="govbook-row">
				<div class="govbook-row__full">
					<div
						class="govbook-region govbook-region--footer region region-footer"
					>
						<div class="padding-horizontal">
							<div class="govbook-region__inner govbook-region__inner--footer">
								<div
									id="block-ecc-theme-gov-localgov-poweredbylocalgovdrupal-scarfolk"
									class="block block-localgov-core block-localgov-powered-by-block"
								>
									<span
										>Powered by
										<a
											target="_blank"
											aria-label="Bookinglab | GovBook (opens in new window)"
											class="footer-links"
											href="https://www.bookinglab.co.uk/solutions/gov-book/registrars-and-ceremonies-booking-system/?utm_source=clientbrowser&utm_medium=clientbookingjourney&utm_campaign=registrarsbooking&utm_content=barnsley
                                            "
											>bookinglab | GovBook</a
										></span
									>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</footer>
